module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-attender-3f5fdfb82fefb44b818129dba3f06ffc.png";